import {FormOption} from "@/types";

export {};

declare global {
  interface Array<T extends FormOption> {
    sortByLabel(): Array<T>;
  }
}

Array.prototype.sortByLabel = function (): Array<FormOption> {
  const collator = new Intl.Collator();
  return this.sort(function (a, b) {
    return collator.compare(a.label, b.label);
  });
};